module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mentor-profile-editor"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.working),
      expression: "working"
    }],
    staticClass: "working"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.profile) ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), (_vm.profile.archived) ? _c('div', {
    staticClass: "panel-body archived"
  }, [_c('h4', [_vm._v("Your Mentor Profile has been archived. Please contact staff if you think this is an error.")])]) : _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(2), _vm._v(" "), (_vm.profileIncomplete) ? _c('p', {
    staticClass: "motivation"
  }, [_vm._v("Mentors with a full profile have a 2.5x greater chance of connecting with students")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "instructions"
  }, [(_vm.profileIncomplete) ? _c('span', {
    staticClass: "danger bold"
  }, [_vm._v("Profile Incomplete")]) : _c('span', [(_vm.unsavedWork) ? _c('span', {
    staticClass: "blue"
  }, [_vm._v("Profile ready")]) : _c('span', {
    staticClass: "green"
  }, [_vm._v("Profile published!")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-container"
  }, [_c('ul', {
    staticClass: "tabs clearfix"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: {
        'active': _vm.selectedTab === tab
      },
      on: {
        "click": function($event) {
          _vm.selectedTab = tab
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tab) + "\n                        "), (tab === 'Bio' && _vm.bioIncomplete) ? _c('i', {
      staticClass: "fa fa-exclamation danger"
    }) : _vm._e(), _vm._v(" "), (tab === 'Availability' && !_vm.profile.user.timeZone) ? _c('i', {
      staticClass: "fa fa-exclamation danger"
    }) : _vm._e(), _vm._v(" "), (tab === 'Work Information' && _vm.workInfoIncomplete) ? _c('i', {
      staticClass: "fa fa-exclamation danger"
    }) : _vm._e(), _vm._v(" "), (tab === 'Software' &&
      (!_vm.profile.mentor_software_proficiencies.length || !_vm.profile.mentor_software_proficiencies.find(function (p) { return p.proficiencyLevel > 0; }))) ? _c('i', {
      staticClass: "fa fa-exclamation danger"
    }) : _vm._e(), _vm._v(" "), (tab === 'Skills' &&
      (!_vm.profile.mentor_skill_proficiencies.length || !_vm.profile.mentor_skill_proficiencies.find(function (p) { return p.proficiencyLevel > 0; }))) ? _c('i', {
      staticClass: "fa fa-exclamation danger"
    }) : _vm._e(), _vm._v(" "), (tab === 'Previous Mentees' && _vm.roles.includes('Mentor') && _vm.mentees.length > 2 && (!_vm.selectedMentees || !_vm.selectedMentees.length)) ? _c('i', {
      staticClass: "fa fa-exclamation danger"
    }) : _vm._e(), _vm._v(" "), (tab === 'Work Examples' && (!_vm.profile.gallery || _vm.profile.gallery.length < 4 || !_vm.profile.credits || _vm.profile.credits.length < 4)) ? _c('i', {
      staticClass: "fa fa-exclamation danger"
    }) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'Bio'),
      expression: "selectedTab === 'Bio'"
    }],
    staticClass: "bio row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "image col-xs-3"
  }, [(_vm.profile.featuredImage) ? _c('img', {
    attrs: {
      "src": _vm.profile.featuredImage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "featured-image-controls",
    class: {
      'bold danger': !_vm.profile.featuredImage
    }
  }, [_vm._v("\n                        Featured Artwork "), _c('label', {
    attrs: {
      "for": "featuredImage"
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('input', {
    staticClass: "file",
    attrs: {
      "type": "file",
      "id": "featuredImage"
    },
    on: {
      "change": function($event) {
        _vm.upload($event, 'featuredImage')
      }
    }
  })]), _vm._v(" "), (_vm.roles.includes('Mentor')) ? _c('div', {
    staticClass: "flex demo-reel-url"
  }, [_c('label', [_vm._v("Demo Reel URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.demoReelUrl),
      expression: "profile.demoReelUrl"
    }],
    staticClass: "demoreel",
    attrs: {
      "type": "text",
      "placeholder": "Vimeo or YouTube URL"
    },
    domProps: {
      "value": (_vm.profile.demoReelUrl)
    },
    on: {
      "change": function($event) {
        _vm.unsavedWork = true
      },
      "paste": function($event) {
        _vm.unsavedWork = true
      },
      "keyup": function($event) {
        _vm.unsavedWork = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.demoReelUrl = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "social-sites"
  }, _vm._l((_vm.socialPlatforms), function(platform) {
    return _c('li', [_c('label', [_vm._v(_vm._s(platform))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.socialSites[platform]),
        expression: "socialSites[platform]"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.socialSites[platform])
      },
      on: {
        "keyup": function($event) {
          _vm.unsavedWork = true
        },
        "change": function($event) {
          _vm.unsavedWork = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.socialSites, platform, $event.target.value)
        }
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "text col-xs-9"
  }, [_c('label', {
    class: {
      'bold danger': !_vm.profile.bio || _vm.profile.bio.trim() === '' || _vm.profile.bio.length > 500
    }
  }, [_vm._v("A Short Bio (" + _vm._s(_vm.bioCharCount) + " / 500 char)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bio),
      expression: "profile.bio"
    }],
    domProps: {
      "value": (_vm.profile.bio)
    },
    on: {
      "change": function($event) {
        _vm.unsavedWork = true
      },
      "paste": function($event) {
        _vm.unsavedWork = true
      },
      "keyup": function($event) {
        _vm.unsavedWork = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.bio = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "show-email"
  }, [_c('div', [_vm._v("\n                                Show my email address on my profile\n                            ")]), _vm._v(" "), _c('div', [_c('toggle-button', {
    on: {
      "change": function($event) {
        _vm.unsavedWork = true
      }
    },
    model: {
      value: (_vm.profile.publicEmail),
      callback: function($$v) {
        _vm.profile.publicEmail = $$v
      },
      expression: "profile.publicEmail"
    }
  })], 1)]), _vm._v(" "), _c('label', [_vm._v("I speak fluent:")]), _vm._v(" "), _c('ul', {
    staticClass: "unstyled languages"
  }, _vm._l((_vm.languages), function(language) {
    return _c('li', [_c('label', {
      staticClass: "cursor-pointer"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profile.user.languages),
        expression: "profile.user.languages"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": language,
        "checked": Array.isArray(_vm.profile.user.languages) ? _vm._i(_vm.profile.user.languages, language) > -1 : (_vm.profile.user.languages)
      },
      on: {
        "change": function($event) {
          _vm.unsavedWork = true
        },
        "__c": function($event) {
          var $$a = _vm.profile.user.languages,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = language,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.profile.user.languages = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.profile.user.languages = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.profile.user.languages = $$c
          }
        }
      }
    }), _vm._v("                                        \n                                    " + _vm._s(language) + "\n                                ")])])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'Work Information'),
      expression: "selectedTab === 'Work Information'"
    }]
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "work-information well"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    class: {
      'bold danger': !_vm.profile.company
    }
  }, [_vm._v("I work for")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.company),
      expression: "profile.company",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.company)
    },
    on: {
      "change": function($event) {
        _vm.unsavedWork = true
      },
      "paste": function($event) {
        _vm.unsavedWork = true
      },
      "keyup": function($event) {
        _vm.unsavedWork = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.company = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'bold danger': !_vm.profile.companyUrl
    }
  }, [_vm._v("Company URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.companyUrl),
      expression: "profile.companyUrl",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "http://etc"
    },
    domProps: {
      "value": (_vm.profile.companyUrl)
    },
    on: {
      "change": function($event) {
        _vm.unsavedWork = true
      },
      "paste": function($event) {
        _vm.unsavedWork = true
      },
      "keyup": function($event) {
        _vm.unsavedWork = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.companyUrl = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    class: {
      'bold danger': !_vm.profile.position
    }
  }, [_vm._v("My current position/title is")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.position),
      expression: "profile.position",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.position)
    },
    on: {
      "change": function($event) {
        _vm.unsavedWork = true
      },
      "paste": function($event) {
        _vm.unsavedWork = true
      },
      "keyup": function($event) {
        _vm.unsavedWork = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.position = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    class: {
      'bold danger': !_vm.profile.location
    }
  }, [_vm._v("I am currently living in")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.profile.location),
      expression: "profile.location",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.location)
    },
    on: {
      "change": function($event) {
        _vm.unsavedWork = true
      },
      "paste": function($event) {
        _vm.unsavedWork = true
      },
      "keyup": function($event) {
        _vm.unsavedWork = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.location = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    class: {
      'bold danger': !_vm.profile.industry
    }
  }, [_vm._v("\n                                    I am working in the\n                                ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.industry),
      expression: "profile.industry"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.industry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.unsavedWork = true
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vfx"
    }
  }, [_vm._v("VFX / Film & TV")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video_games"
    }
  }, [_vm._v("Video Game & VR / AR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("Both VFX and Games")])]), _vm._v("\n                                Industry\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "specialties well"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('label', {
    class: {
      'bold danger': !_vm.profile.specialties || !_vm.profile.specialties.length
    }
  }, [_vm._v("I am comfortable with:")]), _vm._v(" "), _c('ul', {
    staticClass: "specialties"
  }, _vm._l((_vm.specialties), function(specialty) {
    return _c('li', [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": specialty
      },
      domProps: {
        "checked": _vm.profile.specialties.indexOf(specialty) > -1,
        "value": specialty
      },
      on: {
        "change": function($event) {
          _vm.setSpecialties(specialty);
          _vm.unsavedWork = true
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": specialty
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("deslugify")(specialty)) + "\n                                    ")])])
  }))])]), _vm._v(" "), (_vm.nextTermVenue !== 'campus') ? _c('div', {
    staticClass: "specialties well"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', [_c('label', [_vm._v("Student Learning Path(s) Applicable to your Experience:")]), _vm._v(" "), _c('ul', {
    staticClass: "specialties"
  }, _vm._l((_vm.mentorPaths), function(path) {
    return _c('li', [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'path_' + path.id
      },
      domProps: {
        "checked": _vm.profile.paths.includes(path.id),
        "value": path.name
      },
      on: {
        "change": function($event) {
          _vm.setPaths(path)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'path_' + path.id
      }
    }, [_vm._v("\n                                            " + _vm._s(path.name) + "\n                                        ")])])
  }))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'Availability'),
      expression: "selectedTab === 'Availability'"
    }]
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "availability-table well"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "time-availability"
  }, [_c('div', {
    staticClass: "mentor-timezones"
  }, [_c('label', {
    class: {
      'bold danger': !_vm.profile.user.timeZone
    }
  }, [_vm._v("Select your time zone:")]), _vm._v(" "), _c('br'), _c('label', {
    staticClass: "bold"
  }, [_vm._v("Please pick the major city closest to you, in your time zone.")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.timeZoneResults,
      "label": "label",
      "index": "value",
      "get-option-label": _vm.getOptionLabel,
      "placeholder": "Time Zone"
    },
    on: {
      "search": _vm.searchTimeZones,
      "change": function($event) {
        _vm.unsavedWork = true
      }
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.handleEmptyTimeZoneSearch($event)
      }
    },
    model: {
      value: (_vm.profile.user.timeZone),
      callback: function($$v) {
        _vm.profile.user.timeZone = $$v
      },
      expression: "profile.user.timeZone"
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n                                        Begin typing...\n                                    ")])], 2)], 1), _vm._v(" "), (_vm.roles.includes('Mentor')) ? _c('div', {
    staticClass: "line"
  }, [_c('span', {
    class: {
      'bold danger': !_vm.profile.availableDays
    }
  }, [_vm._v("\n                                        I prefer to connect with my mentees on \n                                    ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.availableDays),
      expression: "profile.availableDays"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "click": function($event) {
        _vm.unsavedWork = true
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.availableDays = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekdays"
    }
  }, [_vm._v("week days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekends"
    }
  }, [_vm._v("weekends")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("any time of the week")])]), _vm._v(" "), _c('span', {
    class: {
      'bold danger': !_vm.profile.availableTimes
    }
  }, [_vm._v("\n                                        during the\n                                    ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.availableTimes),
      expression: "profile.availableTimes"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "click": function($event) {
        _vm.unsavedWork = true
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.availableTimes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "selected": ""
    }
  }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mornings"
    }
  }, [_vm._v("mornings")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "afternoons"
    }
  }, [_vm._v("afternoons")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "evenings"
    }
  }, [_vm._v("evenings")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "any"
    }
  }, [_vm._v("anytime of the day")])])]) : _vm._e()]), _vm._v(" "), (_vm.roles.includes('Mentor')) ? _c('div', [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._l((_vm.profile.mentor_availabilities.filter(function (a, i) { return i < 3; })), function(availability) {
    return _c('div', {
      staticClass: "line"
    }, [_c('div', [_vm._v("\n                                    " + _vm._s(_vm._f("intakeDate")(availability.term.startDate)) + " (" + _vm._s(_vm._f("capitalize")(availability.venue)) + ")\n                                ")]), _vm._v(" "), _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (availability.status),
        expression: "availability.status"
      }],
      staticClass: "form-control",
      class: {
        'disabled': _vm.termHasStarted(availability.term)
      },
      attrs: {
        "disabled": _vm.termHasStarted(availability.term),
        "title": _vm.termHasStarted(availability.term) ? 'You cannot change the status of a term that has already started' : ''
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          availability.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.validateAvailability($event, availability)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "default": "",
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "unconfirmed",
        "disabled": ""
      }
    }, [_vm._v("Unconfirmed")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "available"
      }
    }, [_vm._v("Available")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "unavailable"
      }
    }, [_vm._v("Unavailable")])])]), _vm._v(" "), _c('div', [(availability.status === 'available' || availability.status === 'unconfirmed') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (availability.seats),
        expression: "availability.seats"
      }],
      staticClass: "form-control",
      class: {
        'disabled': _vm.termHasStarted(availability.term)
      },
      attrs: {
        "disabled": _vm.termHasStarted(availability.term),
        "title": _vm.termHasStarted(availability.term) ? 'You cannot change the status of a term that has already started' : ''
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          availability.seats = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.validateSeats($event, availability)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "default": "",
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v("choose")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("1")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("2")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("3")]), _vm._v(" "), (_vm.canHaveFourSeats) ? _c('option', {
      attrs: {
        "value": "4",
        "disabled": ""
      }
    }, [_vm._v("4")]) : _vm._e()]) : _vm._e()])])
  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'Software'),
      expression: "selectedTab === 'Software'"
    }]
  }, [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), (_vm.software) ? _c('ul', {
    staticClass: "software"
  }, _vm._l((_vm.software), function(program) {
    return _c('li', {
      staticClass: "pill",
      class: {
        'very-familiar': _vm.softwareProficiencies[program.id] && _vm.softwareProficiencies[program.id].proficiencyLevel === 2, 'familiar': _vm.softwareProficiencies[program.id] && _vm.softwareProficiencies[program.id].proficiencyLevel === 2,
          'familiar': _vm.softwareProficiencies[program.id] && _vm.softwareProficiencies[program.id].proficiencyLevel === 2, 'familiar': _vm.softwareProficiencies[program.id] && _vm.softwareProficiencies[program.id].proficiencyLevel === 1,
          'unfamiliar': !_vm.softwareProficiencies[program.id] || (_vm.softwareProficiencies[program.id] && _vm.softwareProficiencies[program.id].proficiencyLevel === 0)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setSoftwareProficiency(program);
          _vm.unsavedWork = true
        }
      }
    }, [_vm._v("\n                            " + _vm._s(program.name) + "\n                        ")])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'Skills'),
      expression: "selectedTab === 'Skills'"
    }]
  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), (_vm.skills) ? _c('ul', {
    staticClass: "skills"
  }, _vm._l((_vm.skills), function(skill) {
    return _c('li', {
      staticClass: "pill",
      class: {
        'very-familiar': _vm.mentorSkills[skill.id] && _vm.mentorSkills[skill.id].proficiencyLevel === 2, 'familiar': _vm.mentorSkills[skill.id] && _vm.mentorSkills[skill.id].proficiencyLevel === 2,
          'familiar': _vm.mentorSkills[skill.id] && _vm.mentorSkills[skill.id].proficiencyLevel === 2, 'familiar': _vm.mentorSkills[skill.id] && _vm.mentorSkills[skill.id].proficiencyLevel === 1,
          'unfamiliar': !_vm.mentorSkills[skill.id] || (_vm.mentorSkills[skill.id] && _vm.mentorSkills[skill.id].proficiencyLevel === 0)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setSkill(skill);
          _vm.unsavedWork = true
        }
      }
    }, [_vm._v("\n                            " + _vm._s(skill.name) + "\n                        ")])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'Work Examples'),
      expression: "selectedTab === 'Work Examples'"
    }]
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "work-examples"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateProfile()
      }
    }
  }, [_vm._v("Save Profile")])]), _vm._v(" "), _c('h5', {
    staticClass: "bold text-center",
    class: {
      'danger': !_vm.profile.gallery || _vm.profile.gallery.length < 4
    }
  }, [_vm._v("Personal or Professional Work"), _c('br'), _vm._v("(4-8 images required)")]), _vm._v(" "), _c('div', {
    staticClass: "image-uploader",
    class: {
      'dragged-over': _vm.draggedOver === 'gallery',
        'disabled': _vm.profile.gallery && _vm.profile.gallery.length >= 8
    },
    on: {
      "drop": function($event) {
        _vm.draggedOver = null
      },
      "dragleave": function($event) {
        _vm.draggedOver = null
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.draggedOver = 'gallery'
      }
    }
  }, [_c('label', [_vm._v("\n                                Drag 4-8 images here\n                                "), _c('input', {
    attrs: {
      "type": "file",
      "name": "gallery",
      "multiple": "",
      "accept": "image/jpeg,image/png"
    },
    on: {
      "change": function($event) {
        _vm.upload($event, 'gallery')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Re-order / Remove Personal or Professional Work")]), _vm._v(" "), _c('draggable', {
    staticClass: "work-gallery",
    model: {
      value: (_vm.profile.gallery),
      callback: function($$v) {
        _vm.profile.gallery = $$v
      },
      expression: "profile.gallery"
    }
  }, _vm._l((_vm.profile.gallery), function(image, $i) {
    return _c('div', {
      staticClass: "gallery-item"
    }, [_c('img', {
      attrs: {
        "src": image
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-ban blue cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeWorkImage('gallery', $i)
        }
      }
    })])
  })), _vm._v(" "), _c('h5', {
    staticClass: "bold text-center",
    class: {
      'danger': !_vm.profile.credits || _vm.profile.credits.length < 4
    }
  }, [_vm._v("Credits (Box Art / Posters)"), _c('br'), _vm._v("(4-8 images required)")]), _vm._v(" "), _c('div', {
    staticClass: "image-uploader",
    class: {
      'dragged-over': _vm.draggedOver === 'credits',
        'disabled': _vm.profile.credits && _vm.profile.credits.length >= 8
    },
    on: {
      "drop": function($event) {
        _vm.draggedOver = null
      },
      "dragleave": function($event) {
        _vm.draggedOver = null
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.draggedOver = 'credits'
      }
    }
  }, [_c('label', [_vm._v("\n                                Drag 4-8 images here\n                                "), _c('input', {
    attrs: {
      "type": "file",
      "name": "credits",
      "multiple": "",
      "accept": "image/jpeg,image/png"
    },
    on: {
      "change": function($event) {
        _vm.upload($event, 'credits')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Re-order / Remove Credits (Box Art / Posters)")]), _vm._v(" "), _c('draggable', {
    staticClass: "work-gallery credits",
    model: {
      value: (_vm.profile.credits),
      callback: function($$v) {
        _vm.profile.credits = $$v
      },
      expression: "profile.credits"
    }
  }, _vm._l((_vm.profile.credits), function(image, $i) {
    return _c('div', {
      staticClass: "gallery-item"
    }, [_c('img', {
      attrs: {
        "src": image
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-ban blue cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeWorkImage('credits', $i)
        }
      }
    })])
  }))], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'Previous Mentees'),
      expression: "selectedTab === 'Previous Mentees'"
    }]
  }, [_vm._m(15), _vm._v(" "), _c('ul', {
    staticClass: "past-students unstyled"
  }, [_vm._m(16), _vm._v(" "), _vm._l((_vm.selectedMentees), function(student, $i) {
    return _c('li', {
      staticClass: "mentee"
    }, [_c('span', {
      staticClass: "cursor-pointer mentee-name",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openFeaturedMentee === $i ? _vm.openFeaturedMentee = null : _vm.openFeaturedMentee = $i
        }
      }
    }, [_vm._v("\n                                " + _vm._s(student.name) + "\n                                "), (_vm.openFeaturedMentee === $i) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeMentee($i)
        }
      }
    }, [_vm._v("Remove Mentee from Profile")])]), _vm._v(" "), (_vm.openFeaturedMentee === $i) ? _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "meta"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.path),
        expression: "student.path"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          student.path = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "null",
        "default": ""
      }
    }, [_vm._v("No career path set")]), _vm._v(" "), _vm._l((_vm.paths), function(path) {
      return _c('option', {
        domProps: {
          "value": path.id
        }
      }, [_vm._v("Career Path - " + _vm._s(path.name))])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "links"
    }, [_c('label', {
      staticClass: "blue bold"
    }, [_vm._v("Term")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.term),
        expression: "student.term"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (student.term)
      },
      on: {
        "keyup": function($event) {
          _vm.unsavedWork = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          student.term = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "links"
    }, [_c('label', {
      staticClass: "blue bold"
    }, [_vm._v("Demo Reel")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.reel),
        expression: "student.reel"
      }],
      attrs: {
        "type": "text",
        "placeholder": "YouTube or Vimeo"
      },
      domProps: {
        "value": (student.reel)
      },
      on: {
        "keyup": function($event) {
          _vm.unsavedWork = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          student.reel = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "links"
    }, [_c('label', {
      staticClass: "blue bold"
    }, [_vm._v("Artstation")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.artstation),
        expression: "student.artstation"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (student.artstation)
      },
      on: {
        "keyup": function($event) {
          _vm.unsavedWork = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          student.artstation = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "links"
    }, [_c('label', {
      staticClass: "blue bold"
    }, [_vm._v("LinkedIn")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.linkedin),
        expression: "student.linkedin"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (student.linkedin)
      },
      on: {
        "keyup": function($event) {
          _vm.unsavedWork = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          student.linkedin = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "links"
    }, [_c('label', {
      staticClass: "blue bold"
    }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.email),
        expression: "student.email"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (student.email)
      },
      on: {
        "keyup": function($event) {
          _vm.unsavedWork = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          student.email = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "links",
      attrs: {
        "title": "Please check with the student before making their email address public"
      }
    }, [_c('label', {
      staticClass: "blue bold"
    }, [_vm._v("Make Email Public")]), _vm._v(" "), _c('toggle-button', {
      on: {
        "change": function($event) {
          _vm.unsavedWork = true
        }
      },
      model: {
        value: (student.publicEmail),
        callback: function($$v) {
          student.publicEmail = $$v
        },
        expression: "student.publicEmail"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "links"
    }, [_c('label', {
      staticClass: "blue bold"
    }, [_vm._v("Additional Notes")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (student.notes),
        expression: "student.notes"
      }],
      attrs: {
        "rows": "5"
      },
      domProps: {
        "value": (student.notes)
      },
      on: {
        "keyup": function($event) {
          _vm.unsavedWork = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          student.notes = $event.target.value
        }
      }
    })]), _vm._v(" "), (_vm.openFeaturedMentee === $i) ? _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.updateProfile($event)
        }
      }
    }, [_vm._v("Save Profile")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "artwork"
    }, [_c('h5', [_vm._v("Title Image")]), _vm._v(" "), _c('div', {
      staticClass: "has-remove-button"
    }, [(student.avatar) ? _c('i', {
      staticClass: "fa fa-ban blue cursor-pointer",
      on: {
        "click": function($event) {
          student.avatar = null
        }
      }
    }) : _vm._e(), _vm._v(" "), (student.avatar) ? _c('img', {
      staticClass: "title-image",
      attrs: {
        "src": student.avatar
      }
    }) : _c('div', {
      staticClass: "images-uploader",
      class: {
        'dragged-over': _vm.draggedOver === 'title-image'
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          _vm.addTitleImage($event, student, $i);
          _vm.draggedOver = null
        },
        "dragleave": function($event) {
          _vm.draggedOver = null
        },
        "dragover": function($event) {
          $event.preventDefault();
          _vm.draggedOver = 'title-image'
        }
      }
    }, [_c('span', {
      staticClass: "instructions"
    }, [_vm._v("\n                                                Drag and drop title image from Artwork Library below\n                                            ")])])]), _vm._v(" "), _c('h5', [_vm._v("Additional Images")]), _vm._v(" "), _c('div', {
      staticClass: "images-uploader",
      class: {
        'dragged-over': _vm.draggedOver === 'additional-images'
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          _vm.addArtwork($event, student, $i);
          _vm.draggedOver = null
        },
        "dragleave": function($event) {
          _vm.draggedOver = null
        },
        "dragover": function($event) {
          $event.preventDefault();
          _vm.draggedOver = 'additional-images'
        }
      }
    }, [_c('draggable', {
      staticClass: "additional-images",
      model: {
        value: (student.images),
        callback: function($$v) {
          student.images = $$v
        },
        expression: "student.images"
      }
    }, _vm._l((student.images), function(image, $j) {
      return _c('li', {
        attrs: {
          "draggable": ""
        },
        on: {
          "dragstart": function($event) {
            _vm.setDragData($event, student)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": image
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "fa fa-ban blue cursor-pointer",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.removeImage($i, $j)
          }
        }
      })])
    })), _vm._v(" "), (student.images.length < 4) ? _c('span', {
      staticClass: "instructions"
    }, [_vm._v("\n                                            Drag up to " + _vm._s(4 - student.images.length) + " more image"), (4 - student.images.length > 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" from the Artwork Library here\n                                        ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.openFeaturedMentee === $i) ? _c('div', {
      staticClass: "library"
    }, [(!_vm.menteeArtwork || _vm.menteeArtwork.length === 0) ? _c('div', [_c('h6', [_vm._v("No artwork found")])]) : _c('div', [_c('h5', [_vm._v("Artwork Library")]), _vm._v(" "), _c('ul', {
      staticClass: "artwork-library selectable"
    }, _vm._l((_vm.menteeArtwork), function(image) {
      return _c('li', [_c('a', {
        attrs: {
          "href": image.url,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-external-link"
      })]), _vm._v(" "), _c('v-lazy-image', {
        attrs: {
          "src": image.url,
          "title": image.name,
          "draggable": true
        },
        on: {
          "dragstart": function($event) {
            _vm.setDragData($event, student)
          }
        }
      })], 1)
    }))])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "mentees unstyled"
  }, [_vm._m(17), _vm._v(" "), _vm._l((_vm.mentees), function(mentee, $i) {
    return _c('li', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.notSelected(mentee)),
        expression: "notSelected(mentee)"
      }],
      staticClass: "mentee"
    }, [_c('span', {
      staticClass: "cursor-pointer mentee-name",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleOpen('openAllMentees', $i)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(mentee.firstName) + " " + _vm._s(mentee.lastName) + "\n                                    "), (_vm.openAllMentees.includes($i)) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    }), _vm._v(" "), (!_vm.isDisplayed(mentee)) ? _c('div', [_c('button', {
      staticClass: "btn btn-success bt-xs",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addToProfile(mentee, $i)
        }
      }
    }, [_vm._v("Display on Profile")])]) : _vm._e()]), _vm._v(" "), (_vm.openAllMentees.includes($i)) ? _c('div', {
      staticClass: "mentee-info"
    }, [_c('p', [_vm._v("Career Path: " + _vm._s(_vm.getPathName(mentee.path)))]), _vm._v(" "), (mentee.socialLinks && mentee.socialLinks['ArtStation']) ? _c('p', [_vm._v("Artstation: "), _c('a', {
      staticClass: "cursor-pointer",
      attrs: {
        "href": mentee.socialLinks['ArtStation'],
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(mentee.socialLinks['ArtStation']))])]) : _vm._e(), _vm._v(" "), (mentee.artwork.length === 0 && (!mentee.cloudinaryArtwork || mentee.cloudinaryArtwork.length === 0)) ? _c('div', [_c('h6', [_vm._v("No artwork found")])]) : _c('div', [_c('h5', [_vm._v("Artwork Library")]), _vm._v(" "), _c('ul', {
      staticClass: "artwork-library"
    }, _vm._l((mentee.artwork), function(image) {
      return _c('li', [_c('a', {
        attrs: {
          "href": image.url,
          "target": "_blank"
        }
      }, [_c('v-lazy-image', {
        attrs: {
          "src": image.url,
          "title": image.name,
          "loading": "lazy"
        }
      })], 1)])
    }))])]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateProfile()
      }
    }
  }, [_vm._v("Save Profile")]), _vm._v(" "), (!_vm.profileIncomplete && !_vm.unsavedWork) ? _c('router-link', {
    staticClass: "profile-link btn btn-success",
    attrs: {
      "target": "_blank",
      "to": {
        name: 'mentorProfile',
        params: {
          id: _vm.localStorage.user_id
        }
      }
    }
  }, [_vm._v("\n                    View Profile\n                ")]) : _vm._e(), _vm._v(" "), (_vm.profileIncomplete && !_vm.unsavedWork) ? _c('button', {
    staticClass: "bt btn-danger not-ready",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Profile not ready")]) : _vm._e()], 1), _vm._v(" "), (_vm.unsavedWork) ? _c('div', {
    staticClass: "unsaved-work danger row col-xs-12"
  }, [_vm._v("You have unsaved work")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-folding-cube"
  }, [_c('div', {
    staticClass: "sk-cube1 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube2 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube4 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube3 sk-cube"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Mentor Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "instructions"
  }, [_vm._v("Please fill out all of the tabs. A "), _c('i', {
    staticClass: "fa fa-exclamation"
  }), _vm._v(" sign will appear next to incomplete tabs.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h3', [_vm._v("A Short Bio…")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h3', [_vm._v("Work Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h3', [_vm._v("Work Availability")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Set your term-by-term availability:"), _c('br'), _c('b', [_c('i', [_vm._v("Changing your availability/seats in one term will set all future terms to the same availability/seats")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', [_vm._v("Term")]), _vm._v(" "), _c('div', [_vm._v("Status")]), _vm._v(" "), _c('div', [_vm._v("Number of Mentees")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h3', [_vm._v("Software")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend"
  }, [_c('p', [_vm._v("*in the Mentor Selector they will be represented like this: ")]), _vm._v(" "), _c('span', {
    staticClass: "pill very-familiar"
  }, [_vm._v("Very Familiar")]), _vm._v(" "), _c('span', {
    staticClass: "pill familiar"
  }, [_vm._v("Familiar")]), _c('span', {
    staticClass: "pill unfamiliar"
  }, [_vm._v("Unfamiliar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Are we missing any software? Email us at "), _c('a', {
    attrs: {
      "href": "mailto:mentors@tttc.ca?Subject=Mentor+Selector+Software+Suggestion",
      "target": "_blank"
    }
  }, [_vm._v("mentors@tttc.ca")]), _vm._v(" with your suggestions.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h3', [_vm._v("Skills")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend"
  }, [_c('p', [_vm._v("*in the Mentor Selector they will be represented like this: ")]), _vm._v(" "), _c('span', {
    staticClass: "pill very-familiar"
  }, [_vm._v("Very Familiar")]), _vm._v(" "), _c('span', {
    staticClass: "pill familiar"
  }, [_vm._v("Familiar")]), _c('span', {
    staticClass: "pill unfamiliar"
  }, [_vm._v("Unfamiliar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Are we missing any skills? Email us at "), _c('a', {
    attrs: {
      "href": "mailto:mentors@tttc.ca?Subject=Mentor+Selector+Skill+Suggestion",
      "target": "_blank"
    }
  }, [_vm._v("mentors@tttc.ca")]), _vm._v(" with your suggestions.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h3', [_vm._v("Work Examples")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h3', [_vm._v("Previous Mentees")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "mentee"
  }, [_c('h5', [_vm._v("Displayed on Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "mentee"
  }, [_c('h5', [_vm._v("All Previous Mentees")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0114ec7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentorProfileEditor.vue
// module id = 1959
// module chunks = 2